module.exports = __webpack_public_path__ + "img/search.7bf4d139.svg";